import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const creditPackagesSlide = createSlice({
    name: "creditPackages",
    initialState: {
        page: 0,
        pageCount: 0,
        success: false,
        fail: false,
        listData: null,
        detailData: null,
        responseData: null,
        errorDetailData: null,
        summaryData: null,
        totalRow: 0,
    },
    reducers: {
        doGetCreditPackagesListSuccess: (state, action) => {
            state.listData = action.payload.data;
            state.page = action.payload?.current_page;
			state.pageCount = action.payload?.page_count;
			state.totalRow = action.payload?.total_row;
        },
        doGetCreditPackagesListFail: (state, action) => {
            state.listData = null;
            state.page = 0;
			state.pageCount = 0;
			state.totalRow = 0;
        },
        doGetCreditPackagesSummarySuccess: (state, action) => {
            state.summaryData = action.payload?.data;
        },
        doGetCreditPackagesSummaryFail: (state, action) => {
            state.summaryData = null;
        },
        doGetCreditPackagesDetailSuccess: (state, action) => {
            state.detailData = action.payload.data;
        },
        doGetCreditPackagesDetailFail: (state, action) => {
            state.detailData = null;
        },
        doAddCreditPackagesSuccess: (state, action) => {
            state.success = true;
            state.fail = false;
			state.responseData = action.payload;
        },
        doAddCreditPackagesFail: (state, action) => {
            state.success = false;
            state.fail = true;
			state.errorDetailData = action.payload;
        },

        doUpdateCreditPackagesSuccess: (state, action) => {
            state.success = true;
            state.fail = false;
        },
        doUpdateCreditPackagesFail: (state, action) => {
            state.success = false;
            state.fail = true;
			state.errorDetailData = action.payload;
        },
        resetCreditPackagesStateSuccess: (state, action) => {
            state.success = action.payload;
            state.fail = action.payload;
            state.detailData = null;
			state.errorDetailData = null;
        },
    },
});

export const doGetCreditPackagesList = (param) => async (dispatch) => {
    try {
        let url = `/api/admin/credit-package?page=${param.page}&size=${param.limit}`;
        if(param.filter) {
            url += `&filter=${encodeURIComponent(param.filter)}`;
        }

        const response = await axios.get(url);
        dispatch(doGetCreditPackagesListSuccess(response.data));
    } catch (error) {
        dispatch(doGetCreditPackagesListFail(error.response));
    }
};

export const doGetCreditPackagesSummary = () => async (dispatch) => {
    try {
        const url = `/api/admin/credit-package/summary`;

        const response = await axios.get(url);
        dispatch(doGetCreditPackagesSummarySuccess(response.data));
    } catch (error) {
        dispatch(doGetCreditPackagesSummaryFail(error.response));
    }
};

export const doGetCreditPackagesDetail = (param) => async (dispatch) => {
    try {
        let url = `/api/admin/credit-package/${param.credit_package_id}`;
       
        const response = await axios.get(url);
        dispatch(doGetCreditPackagesDetailSuccess(response.data));
    } catch (error) {
        dispatch(doGetCreditPackagesDetailFail(error.response));
    }
};

export const doAddCreditPackages = (param) => async (dispatch) => {
    try {
        const url = `/api/admin/credit-package`;

        const response = await axios.post(url, param);
        dispatch(doAddCreditPackagesSuccess(response.data));
    } catch (error) {
        dispatch(doAddCreditPackagesFail(error.response));
    }
};

export const doUpdateCreditPackages = (param, credit_package_id) => async (dispatch) => {
    try {
        const url = `/api/admin/credit-package/${credit_package_id}`;

        const response = await axios.put(url, param);
        dispatch(doUpdateCreditPackagesSuccess(response.data));
    } catch (error) {
        dispatch(doUpdateCreditPackagesFail(error.response));
    }
};


export const resetCreditPackagesState = () => async (dispatch) => {
    dispatch(resetCreditPackagesStateSuccess(false));
 };

export const { 
    doGetCreditPackagesListSuccess,
    doGetCreditPackagesListFail,
    doGetCreditPackagesSummarySuccess,
    doGetCreditPackagesSummaryFail,
    doGetCreditPackagesDetailSuccess,
    doGetCreditPackagesDetailFail,
    doAddCreditPackagesSuccess,
    doAddCreditPackagesFail,
    doUpdateCreditPackagesSuccess,
    doUpdateCreditPackagesFail,
    resetCreditPackagesStateSuccess,
} = creditPackagesSlide.actions;

export const getCreditPackagesList = (state) => state.creditPackages?.listData;
export const getCreditPackagesListPage = (state) => state.creditPackages?.page;
export const getCreditPackagesListPageCount = (state) => state.creditPackages?.pageCount;
export const getCreditPackagesListTotal = (state) => state.creditPackages?.totalRow;
export const getCreditPackagesSummary = (state) => state.creditPackages?.summaryData;
export const getCreditPackagesDetail = (state) => state.creditPackages?.detailData;
export const getCreditPackagesErrorDetailData = (state) => state.creditPackages?.errorDetailData;
export const getAddCreditPackagesSuccess = (state) => state.creditPackages?.success;
export const getAddCreditPackagesFail = (state) => state.creditPackages?.fail;
export const getAddCreditPackagesResponseData = (state) => state.creditPackages?.responseData;

export default creditPackagesSlide.reducer;
